<template>
  <div class="chartOne">
    <div class="titleall">
      <!-- <h6 class="title" :style="themetype == 'chalk' ? 'color:#fff' : ''">{{ chartTitle }}</h6> -->
      <span class="tspan">{{ chartUnit }}</span>
    </div>
    <div :id="codMain" class="codMain"></div>
  </div>
</template>

<script>
import * as XLSX from "xlsx";
import FileSaver from "file-saver";
import { mapState } from "vuex";
export default {
  props: {
    codMain: String,
    ChartData: Object,
    firstindex: Number,
    toolboxShow: Boolean,
  },
  data() {
    return {
      // one: this.ChartData,
      themetype: null,
      one: this.ChartData,
      myChart: null,
      timer: null,
      codChart: null,
      chartData: {},
      seriesData: [],
      openIndex: null,
      chartTitle: "",
      chartUnit: "",
      initOption: {
        backgroundColor: '',
        animation: true,
        animationDuration: 1500,
        dataZoom: [
          {
            type: "inside",
          },
        ],
        legend: {
          data: "",
          itemHeight: 11,
          itemWidth: 22,
          textStyle: {
            rich: {
              a: {
                verticalAlign: "middle",
              },
            },
            padding: [0, 0, -2, 0], //[上、右、下、左]
          },
          // orient: 'vertical',  //垂直显示
          // y: 'center',    //延Y轴居中
          // x: 'right' //居右显示
        },
        grid: {
          top: "12%",
          left: "3%",
          right: "3%",
          bottom: "3%",
          containLabel: true,
        },
        toolbox: {
          y: 0,
          feature: {
            dataView: {},
            // saveAsImage: { show: true },
          },
          show: this.$props.toolboxShow,
        },
        xAxis: {
          type: "category",
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: false
          }
        },
        tooltip: {
          confine: true,
          trigger: "axis", // 当鼠标移动到坐标轴时触发
          axisPointer: {
            type: "line",
            z: 0,
            lineStyle: {
              color: "#2D3443",
            },
          },
          textStyle: {
            align: "left",
          },
          extraCssText: "z-index: 99999",
        },
        series: [
          {
            name: "",
            data: "",
            symbol: "none", //去掉折线图中的节点
            smooth: true, //true 为平滑曲线，false为直线
            lineStyle: { width: 1.6 },
            type: "line",
            label: {
              show: false, // 是否显示文字
              position: "right", // 文字位置
            },
            itemStyle: {
              lineStyle: {
                color: '"#1890ff"', //改变折线颜色
                width: 1.2,
              },
            },
            zlevel: 999,
          },
        ],
      },
    };
  },
  beforeDestroy() {
    //2.销毁前清除定时器
    // this.myChart.clear()

    clearInterval(this.timer);
  },
  mounted() {
    let theme = localStorage.getItem("theme")
      ? JSON.parse(localStorage.getItem("theme"))
      : "light";
    this.themetype = theme == "dark" ? 'chalk' : 'no';
    this.initChart();
    this.timer = window.setInterval(() => {
      setTimeout(this.initChart(), 0);
    }, 300000);
    window.addEventListener("resize", () => {
      this.codChart.resize();
    });
  },
  computed: {
    ...mapState(["theme"]),
  },
  watch: {
    "$store.state.open"(newVal, oldVal) {
      this.$nextTick(() => {
        // this.codChart.resize();
        setTimeout(() => {
          console.log(this.codChart);
          this.codChart.resize();
        }, 10);
      });
    },
    ChartData(newval) {
      this.codChart.clear();
      if (newval) {
        this.initChart();
      }
    },
    theme(newval) {
      // console.log("nidaye");
      this.themetype = newval
      this.codChart.dispose();
      this.initChart();
    },
  },
  methods: {
    initChart() {
      console.log(this.ChartData);
      this.chartTitle = this.ChartData.title;
      // console.log(this.chartTitle);
      this.chartUnit = this.ChartData.legend[0].unit;
      if (this.chartUnit == '-') {
        this.chartUnit = ''
      }
      this.initOption.xAxis.data = this.ChartData.xAxis;
      this.initOption.yAxis = []
      this.initOption.series = []
      //   const legendData = this.ChartData.legend.map((item) => {
      //     return item.name;
      //   });
      //   this.initOption.legend.data = legendData;
      let selected_item = {};
      this.ChartData.legend.map((item, index, array) => {
        var key_name = item.name;
        // if (index > 1) {
        //   selected_item[key_name] = false;
        // } else {
        //   selected_item[key_name] = true;
        // }
        this.initOption.title = {
          left: "center",
          text: this.chartTitle,
          show: false,
        };
        this.initOption.toolbox.feature.dataView = {
          show: true,
          readOnly: false,
          lang: ["数据视图", "关闭", "导出Excel"], // 这里将刷新改成其他用途
          optionToContent(opt) {
            const seriesExcel = opt.series; // 折线图数据
            // console.log(seriesExcel);
            const axisExcel = opt.xAxis[0].data; // 这里看你放的是x轴还是y轴
            let tdHeads = '<td  style="padding: 0 10px">时间</td>'; // 表头
            console.log(121212);
            let tdBodys = ""; // 数据
            seriesExcel.forEach(function (item) {
              // 组装表头
              tdHeads += '<td style="padding: 0 10px">' + item.name + "</td>";
            });
            let table =
              '<table id="exportTab" border="1" style="margin-left:20px;border-collapse:collapse;font-size:14px;text-align:center;"><tbody><tr>' +
              tdHeads +
              " </tr>";
            for (let i = 0, l = axisExcel.length; i < l; i++) {
              console.log(axisExcel.length);
              for (let j = 0; j < seriesExcel.length; j++) {
                // 组装表数据
                tdBodys +=
                  "<td>" +
                  (seriesExcel[j].data[i] !== null
                    ? seriesExcel[j].data[i].toFixed(2)
                    : "-") +
                  "</td>";
              }
              table +=
                '<tr><td style="padding: 0 10px">' +
                axisExcel[i] +
                tdBodys +
                "</tr>";
              tdBodys = "";
            }
            table += "</tbody></table>";
            return table;
          },

          // 重置刷新事件方法

          contentToOption(dom, opt) {
            function getFormatDate_XLSX(serial) {
              var utc_days = Math.floor(serial - 25569);
              var utc_value = utc_days * 86400;
              var date_info = new Date(utc_value * 1000);
              var fractional_day = serial - Math.floor(serial) + 0.0000001;
              var total_seconds = Math.floor(86400 * fractional_day);
              var seconds = total_seconds % 60;
              total_seconds -= seconds;
              var hours = Math.floor(total_seconds / (60 * 60));
              var minutes = Math.floor(total_seconds / 60) % 60;
              var d = new Date(
                date_info.getFullYear(),
                date_info.getMonth(),
                date_info.getDate(),
                hours,
                minutes,
                seconds
              );
              //得到Date()对象后，便可进行日期格式化了！
              var add0 = (m) => (m < 10 ? "0" + m : m);
              var date = d.getTime();
              date = new Date(d.getTime() - 43 * 1000);
              // console.log(date);
              let Y = date.getFullYear() + "-";
              let M =
                (date.getMonth() + 1 < 10
                  ? "0" + (date.getMonth() + 1)
                  : date.getMonth() + 1) + "-";
              let D =
                (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) +
                " ";
              let h =
                (date.getHours() < 10
                  ? "0" + date.getHours()
                  : date.getHours()) + ":";
              let m =
                (date.getMinutes() < 10
                  ? "0" + date.getMinutes()
                  : date.getMinutes()) + ":";
              let s =
                date.getSeconds() < 10
                  ? "0" + date.getSeconds()
                  : date.getSeconds();
              return Y + M + D + h + m + s;
            }

            let wb = XLSX.utils.table_to_book(
              document.getElementById("exportTab")
            );
            console.log(wb.Sheets.Sheet1);
            for (let i in wb.Sheets.Sheet1) {
              if (
                i !== "!cols" &&
                i != "!fullref" &&
                i != "!merges" &&
                i != "!ref" &&
                i != "!rows"
              ) {
                if (wb.Sheets.Sheet1[i].z === "m/d/yy") {
                  wb.Sheets.Sheet1[i].v = getFormatDate_XLSX(
                    wb.Sheets.Sheet1[i].v
                  );
                  wb.Sheets.Sheet1[i].t = "s";
                  delete wb.Sheets.Sheet1[i].z;
                }
              }
            }
            /* 获取二进制字符串作为输出 */
            let wbout = XLSX.write(wb, {
              bookType: "xlsx",
              bookSST: true,
              type: "array",
            });
            try {
              FileSaver.saveAs(
                //Blob 对象表示一个不可变、原始数据的类文件对象。
                //Blob 表示的不一定是JavaScript原生格式的数据。
                //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
                //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
                new Blob([wbout], { type: "application/octet-stream" }),
                //设置导出文件名称
                `图形分析.xlsx`
              );
            } catch (e) {
              if (typeof console !== "undefined") console.log(e, wbout);
            }
            console.log(wbout);
            return wbout;
          },
        };
        this.initOption.yAxis = [
          {
            type: "value",
            splitLine: {
              show: false
            }
          },
        ];
        if (index === 0) {
          this.initOption.series[index] = {
            name: item.name,
            data: item.yAxis,
            symbol: "none",
            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1,
                  [{
                    offset: 0,
                    color: 'rgba(165, 197, 250, 1) '
                  }, {
                    offset: 1, color: 'rgba(241, 246, 254, 1)'
                  }]),
              },
            },
            smooth: false,
            lineStyle: { width: 1.6 },
            type: "line",
            label: {
              show: false,
              position: "right",
            },
            itemStyle: {
              normal: {
                color: '#498AF4', //改变折线点的颜色
                lineStyle: {
                  color: '#498AF4',//改变折线颜色

                }
              }
            },
          };
        } else {
          // console.log(item);
          this.initOption.series[index] = {
            name: item.name,
            data: item.yAxis,
            symbol: "none", //去掉折线图中的节点
            smooth: false, //true 为平滑曲线，false为直线
            lineStyle: { width: 1.6 },
            type: "line",
            // yAxisIndex: index,
            label: {
              show: false, // 是否显示文字
              position: "right", // 文字位置
            },
          };
        }
      });
      if (this.firstindex == 0) {

        this.initOption.legend.selected = selected_item;
      }
      console.log(this.initOption);
      let newPromise = new Promise((resolve) => {
        resolve();
      });
      newPromise.then(() => {
        // console.log(this.theme);
        this.myChart = this.$echarts.init(
          document.getElementById(this.codMain),
          this.theme
        ); // 使用dark 、light或无第二参数
        // console.log(myChart);
        this.myChart.setOption(this.initOption);
        this.codChart = this.$echarts.init(
          document.getElementById(this.codMain)
        );
        if (this.codChart == null) {
          this.codChart = this.$echarts.init(
            document.getElementById(this.codMain)
          );
        }
        this.codChart.clear();
        this.codChart.setOption(this.initOption);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.chartOne {
  // background-color: red !important;
  width: 95%;
  // height: 100%;
  margin: 0 auto;
  //   box-shadow: 0px 2px 7px rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  overflow-y: hidden;

  .titleall {
    text-align: center;

    .title {
      display: inline-block;
      font-weight: 500;
      font-size: 18px;
      margin: 9px;
      margin-right: 10px;
    }

    .tspan {
      color: #a6a6a6;
    }
  }

  ::-webkit-scrollbar {
    border-radius: 6px;
    width: 5px !important;
    background-color: #ccc;
  }

  ::-webkit-scrollbar-thumb {
    //滑块部分
    border-radius: 6px;
    background-color: #989898;
    height: 30px;
  }

  .codMain {
    // background-color: red !important;
    width: 100%;
    height: 90%;
    margin: 0 auto;
    z-index: 99;
    // background-color: #fff;
  }

  h6 {
    padding-left: 36px;
    text-align: left;
    font-size: 12px;
    color: rgb(76, 76, 76);
    font-weight: 600;
  }
}
</style>
